/**
 * app.config.ts — single source of truth for all external service URLs and env variables.
 *
 * Every place in the app that needs an external URL or env var should import
 * from here. Nothing outside this file should read `process.env` directly.
 */

const env = process.env

const appConfig = {
  /** Backend Express API base URL (used by the Axios http-client) */
  apiBaseUrl: env.REACT_APP_API_BASE_URL || '',

  /** CloudFront CDN base URL used to construct image src attributes */
  cloudfrontUrl: (env.REACT_APP_CLOUDFRONT_URL || '').replace(/\/$/, ''),

  cloudinary: {
    /**
     * Optional upload proxy URL for local dev / integration tests.
     *
     * When set, this overrides the Cloudinary upload endpoint so you can
     * route through a mock or local proxy without redeploying.
     * In production this should be left empty — the real upload URL is
     * derived from the `cloudName` returned by the server signature endpoint.
     *
     * SAFE to embed in the bundle — it contains no secrets.
     */
    uploadProxyUrl: env.REACT_APP_CLOUDINARY_UPLOAD_PROXY_URL || '',
  },

  // NOTE: CLOUDINARY_API_KEY and CLOUDINARY_CLOUD_NAME must NOT be added here.
  // They are server-only values. The client receives them per-request from the
  // authenticated /api/admin/cloudinary-signature endpoint, so they are never
  // baked into the JS bundle.

  /**
   * YouTube embed base (override for testing / proxy scenarios).
   *
   * youtube-nocookie.com is YouTube's privacy-enhanced mode: the player still
   * loads with the article, but YouTube stores nothing about the reader unless
   * they actually play the video. The player is otherwise identical, and the
   * CSP already permits both hosts.
   */
  youtubeEmbedBase: (env.REACT_APP_YOUTUBE_EMBED_BASE || 'https://www.youtube-nocookie.com').replace(/\/$/, ''),

  /** Social / external links — all external URLs live here, never hardcoded in components */
  social: {
    github: 'https://github.com/ramalingesha',
    linkedin: 'https://linkedin.com/in/ramalingesha',
    email: 'jslipi.ml@gmail.com',
  },
}

export default appConfig
